import React from 'react';
import { AddToCalendar } from '@ramsey-plus-components/add-to-calendar';

const AddToCalendarContainer = () => <AddToCalendar />;

export default AddToCalendarContainer;
